<template>
  <v-layout
    :column="$vuetify.breakpoint.xsOnly"
    :class="['ticket-price-container-step-zkm', !isZkm && 'ticket-price-container-step-regular']"
    :style="{
      'border-top':
        isZkm && event.extraModules.ticketing && shoppingCart.length !== 0 && activeStep !== 1
          ? 'none'
          : '',
    }"
  >
    <v-flex>
      <checkout-timer
        v-if="
          event.extraModules.ticketing && shoppingCart.length !== 0 && activeStep !== 1 && isZkm
        "
        :start-time="startTime"
        :event="event"
        class="timer-zkm"
      />
      <v-layout row wrap :class="[isZkm && 'layout-zkm']">
        <div
          v-if="shoppingCart.length !== 0"
          :class="['zkm-layout-container', !isZkm && 'regular-layout-container']"
        >
          <div v-if="isZkm" class="price-container-title-zkm">
            {{ $t('cart') }}
          </div>
          <div v-else class="price-container-title-regular">
            <span>
              {{ $t('cart') }}
            </span>
            <span v-if="activeStep !== 1 && !hideEditButton" class="edit-cart" @click="$emit('back')">{{
              $t('editShoppingCart')
            }}</span>
          </div>

          <div
            :class="[
              'header-description',
              isZkm && 'header-description-zkm',
              !isZkm && 'header-description-regular',
            ]"
          >
            <div class="zkm-price-table">
              <table class="wp-table">
                <tr class="ticket-list-header">
                  <th v-if="isZkm">{{ $t('ticketType') }}</th>
                  <th v-else>{{ $t('ticketTypeRegular') }}</th>
                  <th>{{ $t('ticketQuantity') }}</th>
                  <th>{{ $t('price') }}</th>
                </tr>
                <tr v-for="ticket in countDuplicate(selectedTickets)" :key="ticket.id">
                  <td class="ticketType">
                    {{ ticket.name }}
                    <div v-if="isZkm">
                      <li
                        v-for="(seatItem, index) in ticketLocations[ticket.id]"
                        :key="index"
                        class="seatRow"
                      >
                        {{ 'Red ' + seatItem.row.match(/\d+/) + ' / Sjedalo ' + seatItem.seats }}
                      </li>
                    </div>
                    <div v-else-if="ticketLocations && Object.keys(ticketLocations).length">
                      <div v-for="location in getTicketLocation(ticket.id)" :key="location">
                        <p style="font-weight: normal; color: #666; margin: 0.5rem 0 0 0">
                          {{ location }}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td class="ticketCount">{{ ticket.count }}</td>
                  <td v-if="isZkm">
                    <span class="single-ticket-price">
                      {{ ticket.price }} {{ ' ' }} {{ currency }}
                    </span>
                  </td>
                  <td v-else>
                    <span class="single-ticket-price">
                      {{ calculatePrice(ticket) }} {{ ' ' }} {{ ticket.currency }}
                    </span>
                  </td>
                </tr>
                <tr
                  v-for="[key, value] in Object.entries(fixedFees)"
                  v-if="!isZkm && Object.keys(fixedFees).length"
                  :key="key"
                  class="fixed-fee-row"
                  @click="openCoreEventFeeDescriptionModal = !openCoreEventFeeDescriptionModal"
                >
                  <td class="ticketType coreevent-fee-title">
                    {{ $t('coreEventFee') }} {{ round(key * 1.25, 2) }}
                    <img
                      v-if="!isZkm"
                      src="/assets/info-rounded.svg"
                      alt="info icon"
                      style="width: 1.5rem; height: 1.5rem"
                    >
                  </td>
                  <td class="ticketCount">{{ value.count }}</td>
                  <td>
                    <span class="single-ticket-price">
                      {{ round(key * value.count * 1.25, 2) }} {{ ' ' }} {{ currency }}
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <v-flex
            v-if="promoCode || displayGiftCardCalculation"
            x12
            :class="['header-description', !isZkm && 'header-description-regular']"
            :style="{
              padding: !isZkm && '10px 0',
              borderTop: '1px solid var(--stroke-one, rgba(151, 151, 151, 0.5))',
            }"
          >
            <div class="element-description">
              <div>{{ $t('subtotalPriceLabel') }}</div>
              <div>{{ subTotalPrice }} {{ currency }}</div>
            </div>
            <div v-if="promoCode" class="element-description">
              <div>{{ $t('orderDiscount') }}</div>
              <div>-{{ discountedPrice.toFixed(2) }} {{ currency }}</div>
            </div>
            <div v-if="displayGiftCardCalculation" class="element-description">
              <div>{{ $t('giftCardDiscount') }}</div>
              <div>-{{ Number(giftCard.amount).toFixed(2) }} {{ currency }}</div>
            </div>
          </v-flex>
          <v-flex
            v-if="getFixedFeePerTicket && isZkm && calculateCoreEventFixedFee() > 0"
            x12
            class="header-description"
            :style="{
              borderTop: '1px solid var(--stroke-one, rgba(151, 151, 151, 0.5))',
            }"
          >
            <div
              class="element-description"
              @click="openCoreEventFeeDescriptionModal = !openCoreEventFeeDescriptionModal"
            >
              <div>{{ $t('coreEventFee') }}:</div>
              <div>{{ calculateCoreEventFixedFee() }} {{ currency }}</div>
            </div>
          </v-flex>
          <div v-if="isZkm" class="total-price-description-zkm">
            <v-flex xs12 class="total-price-description">
              <div>{{ $t('inTotal') }}</div>
              <div class="total-price">{{ totalPrice }} {{ currency }}</div>
            </v-flex>
            <main-button
              id="continuePurchaseButton"
              :class="[
                'zkmButton',
                event.extraModules.ticketing &&
                  shoppingCart.length !== 0 &&
                  activeStep !== 1 &&
                  isZkm &&
                  'zkmButtonHide',
              ]"
              depressed
              :color="'#333'"
              :text="$t('continueShopping')"
              :disabled="activeStep !== 1 && (disabledSubmitButton || !user)"
              @click="handleSubmit"
            />
            <div v-if="!user && activeStep !== 1" class="not-logged-in not-logged-in-zkm">
              {{ $t('signInToContinue') }}
            </div>
          </div>
        </div>
      </v-layout>
    </v-flex>
    <div v-if="!isZkm" class="total-price-description-regular-container">
      <div class="total-price-description-regular">
        <div class="total-price-container">
          <span class="total-price"> {{ totalPrice }} {{ currency }} </span>
        </div>
        <main-button
          id="continuePurchaseButton"
          depressed
          color="#333"
          style="flex: 1"
          :text="activeStep === 1 ? $t('continueShoppingCart') : $t('confirmShoppingCart')"
          :disabled="
            (activeStep !== 1 && (disabledSubmitButton || !user)) ||
              (activeStep === 1 && !isTicketMinimumValid)
          "
          @click="handleSubmit()"
        />
      </div>
      <div v-if="!user && activeStep !== 1" class="not-logged-in">{{ $t('signInToContinue') }}</div>
    </div>
    <core-event-fee-description-modal
      v-if="openCoreEventFeeDescriptionModal"
      @close="openCoreEventFeeDescriptionModal = !openCoreEventFeeDescriptionModal"
    />
  </v-layout>
</template>

<script>
import { round } from 'mathjs'
import { exchangeRate } from '@/utils'
import { OrganizationCustomTicketFee } from '@/types'
import { first, minBy } from 'lodash'
import CheckoutTimer from './checkout-timer.vue'
import CoreEventFeeDescriptionModal from '@/components/tickets/core-event-fee-description-modal.vue'

const PromoCodeDiscountType = Object.freeze({
  AMOUNT: 'AMOUNT',
  PERCENTAGE: 'PERCENTAGE',
})
export default {
  name: 'ticket-price-list',
  components: {
    CoreEventFeeDescriptionModal,
    CheckoutTimer,
  },
  props: {
    selectedTickets: {
      type: Array,
      default: () => {
        return []
      },
    },
    promoCode: {
      type: Object,
      default: null,
    },
    ticketLocations: {
      type: Object,
      default: null,
    },
    event: {
      type: Object,
      default: null,
    },
    membership: {
      type: Object,
      default: null,
    },
    startTime: {
      type: Date,
    },
    subscription: {
      type: Array,
      default: () => [],
    },
    shoppingCart: {
      type: Array,
      default: () => {
        return []
      },
    },
    activeStep: {
      type: Number,
      default: null,
    },
    user: {
      type: Object,
      default: null,
    },
    giftCard: {
      type: Object,
      default: null,
    },
    hideEditButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      exchangeRate: exchangeRate,
      subTotalPrice: this.calculateSubTotalPrice(),
      fixedFees: {},
      discountedPrice: this.calculateDiscountedPrice(),
      totalPrice: this.calculateTotalPrice(),
      currency: first(this.selectedTickets).currency,
      eventColor: this.event.eventTemplateId
        ? '#333'
        : this.getThemeStyle(this.event.coverImagePrimaryColor, null, 'primary'),
      openCoreEventFeeDescriptionModal: false,
      disabledSubmitButton: false,
    }
  },
  computed: {
    isZkm() {
      return this.event.organization.id == process.env.VUE_APP_ZKM_ORGANIZATION_ID
    },
    getFixedFeePerTicket() {
      return (
        this.event.fixedFeePerTicket ||
        (this.event.organization && this.event.organization.fixedFeePerTicket) ||
        0
      )
    },
    displayGiftCardCalculation() {
      return this.giftCard && this.giftCard.amount && this.giftCard.isInRange
    },
    isTicketMinimumValid() {
      let valid = true
      this.countDuplicate(this.selectedTickets).forEach(ticket => {
        if (
          ticket.itemMeta &&
          ticket.itemMeta.min &&
          ticket.count > 0 &&
          ticket.count < ticket.itemMeta.min
        ) {
          valid = false
        }
      })

      return valid
    },
  },
  watch: {
    selectedTickets: {
      handler(_) {
        this.recalculatePrices()
      },
    },
    promoCode: {
      handler(_) {
        this.recalculatePrices()
      },
    },
    giftCard: {
      handler(_) {
        this.totalPrice = this.calculateTotalPrice()
      },
    },
  },
  mounted() {
    this.calculateCoreEventFixedFee()
  },
  methods: {
    getFixedFeeForSelectedTicket(ticketPrice) {
      let ticketFee =
        this.event.fixedFeePerTicket ||
        (this.event.organization && this.event.organization.fixedFeePerTicket) ||
        0
      const customOrganizationFees = OrganizationCustomTicketFee[Number(this.event.organization.id)]
      if (customOrganizationFees) {
        ticketFee = this.getTicketFee(ticketPrice, customOrganizationFees)
      }

      return ticketFee
    },
    round,
    getTicketFee(price, organizationFees) {
      let ticketFee = 0
      for (const key in organizationFees) {
        const ranges = organizationFees[key]
        if (price >= ranges.min && price <= ranges.max) {
          return (ticketFee = Number(key))
        }
      }

      return ticketFee
    },
    getTicketLocation(ticketId) {
      const locations = []
      if (!this.ticketLocations[ticketId]) {
        return
      }
      this.ticketLocations[ticketId].map(location =>
        locations.push(
          `${location['section']} / ${location['row']} / ${
            location.isTable ? 'Table' : 'Seat'
          }-${location['seats'].join(',')}`,
        ),
      )

      return locations
    },

    transformSeatString(seatString) {
      seatString = seatString
        .replace(/Section-|-/g, '')
        .replace(/(\d+)_Row/g, 'Red ')
        .replace('Seat', '/ Sjedalo ')
        .replace('_', ' ')

      return seatString
    },
    recalculatePrices() {
      this.subTotalPrice = this.calculateSubTotalPrice()
      this.totalPrice = this.calculateTotalPrice()
      this.discountedPrice = this.calculateDiscountedPrice()
    },
    calculatePrice(ticket) {
      return (Math.round(ticket.count * ticket.price * 100) / 100).toFixed(2)
    },
    calculateSubTotalPrice() {
      return this.selectedTickets
        .reduce((sum, ticket) => sum + parseFloat(ticket.price), 0)
        .toFixed(2)
    },
    calculateCoreEventFixedFee() {
      this.fixedFees = {}
      let freeTicketCount = 0
      let totalCoreEventFee = 0
      this.selectedTickets.map(t => {
        let ticketPrice = Number(t.price)
        if (this.checkPromoCode(freeTicketCount, t)) {
          ticketPrice =
            this.promoCode.discountType === PromoCodeDiscountType.AMOUNT
              ? t.price - this.promoCode.discountAmount
              : round(t.price - (t.price * this.promoCode.discountPercentage) / 100, 2)
        }
        if (!ticketPrice) {
          return (freeTicketCount += 1)
        } else {
          const fixedFee = this.getFixedFeeForSelectedTicket(ticketPrice)
          if (!fixedFee) {
            return
          }
          const existingFee = this.fixedFees[fixedFee]
          if (existingFee) {
            existingFee.count += 1
          } else {
            this.fixedFees[fixedFee] = { count: 1 }
          }
          totalCoreEventFee += fixedFee * 1.25
        }
      })

      return round(totalCoreEventFee, 2)
    },
    calculateTotalPrice() {
      let promoCodeTickets = 0
      const selectedTicketsWithPrepaidCoupon = this.selectedTickets.filter(t => t.prepaidCoupon)
      let subscriptionTicketWithLowestPrice =
        this.subscription.length &&
        this.subscription[0].couponItemId &&
        selectedTicketsWithPrepaidCoupon.length
          ? minBy(selectedTicketsWithPrepaidCoupon, ticket => {
            return Number(ticket.price)
          }).price
          : 0
      const ticketsPrice = this.selectedTickets.reduce((sum, ticket) => {
        if (this.checkPromoCode(promoCodeTickets, ticket)) {
          promoCodeTickets++

          return (
            sum +
            (this.promoCode.discountType === PromoCodeDiscountType.AMOUNT
              ? ticket.price - this.promoCode.discountAmount
              : round(ticket.price - (ticket.price * this.promoCode.discountPercentage) / 100, 2))
          )
        } else {
          return sum + parseFloat(ticket.price)
        }
      }, 0)

      const coreEventPrice = this.calculateCoreEventFixedFee()

      const giftCardPrice = this.displayGiftCardCalculation ? Number(this.giftCard.amount) : 0

      return round(
        ticketsPrice - Number(subscriptionTicketWithLowestPrice) + coreEventPrice - giftCardPrice,
        2,
      )
    },
    calculateDiscountedPrice() {
      let promoCodeTickets = 0

      return this.selectedTickets.reduce((sum, ticket) => {
        if (this.checkPromoCode(promoCodeTickets, ticket)) {
          promoCodeTickets++

          return (
            sum +
            (this.promoCode.discountType === PromoCodeDiscountType.AMOUNT
              ? this.promoCode.discountAmount
              : round(parseFloat(ticket.price) * (this.promoCode.discountPercentage / 100), 2))
          )
        } else {
          return sum
        }
      }, 0)
    },
    getTotalPrice() {
      return `${this.currency} ${this.totalPrice}`
    },
    countDuplicate() {
      return Object.values(
        this.selectedTickets.reduce((ticketsWithCountObject, ticket) => {
          let ticketIdKey = `${ticket.id}`
          if (!ticketsWithCountObject[ticketIdKey]) {
            ticketsWithCountObject[ticketIdKey] = { ...ticket, count: 1 }
          } else {
            ticketsWithCountObject[ticketIdKey].count += 1
          }

          return ticketsWithCountObject
        }, {}),
      )
    },
    checkPromoCode(promoCodeTicketsCount, ticket) {
      return (
        this.promoCode &&
        this.promoCode.orderItems.map(oi => oi.id).includes(ticket.id) &&
        promoCodeTicketsCount < this.promoCode.ticketsPerOrder &&
        (this.promoCode.orderItems.find(oi => oi.id === ticket.id).OrderItemPromoCode.quantity >
          0 ||
          this.promoCode.orderItems.find(oi => oi.id === ticket.id).OrderItemPromoCode.unlimited)
      )
    },
    trackTicketsPurchase(cart) {
      const mappedTickets = cart.map(ticket => ({
        content_name: ticket.name,
        content_category: 'Event Ticket',
        content_ids: [ticket.id],
        content_type: 'product',
        value: parseFloat(ticket.price),
        currency: ticket.currency,
      }))

      mappedTickets.forEach(ticket => {
        window.fbq('track', 'Purchase', ticket)
      })
    },
    handleSubmit() {
      this.$emit('triggerClick')
      if (
        this.event.extraModules.ticketing &&
        this.shoppingCart.length !== 0 &&
        this.activeStep !== 1
      ) {
        this.trackTicketsPurchase(this.shoppingCart)
        this.$emit('triggerPayment')
      }
    },
  },
}
</script>

<style scoped>
.zkm-layout-container {
  width: 100%;
}

.regular-layout-container {
  padding: 1rem 1.5rem 0 1.5rem;
}

.ticketType {
  width: 20px !important;
}

.seatRow {
  color: var(--grey-10, #666);
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  padding-top: 0.5rem !important;
  line-height: 120%;
}

.ticketType li {
  list-style: none;
  padding: 0;
  margin: 0;
}

.timer-zkm {
  border: solid var(--grey-00, #333);
  border-width: 0 0 2px 0;
  margin-top: 0;
  margin-bottom: 2rem;
}

.single-ticket-price {
  color: #333333;
  font-size: 1rem;
  font-weight: bold;
  line-height: 150%;
}

.ticket-list-header {
  text-transform: uppercase;
  color: #333333;
}

/* .zkmButtonHide {
  display: none;
} */

.wp-table {
  width: 100%;
  margin-top: 1rem;
  border-collapse: collapse;
  table-layout: fixed;
}

.wp-table tr {
  border-bottom: 1px solid var(--stroke-one, rgba(151, 151, 151, 0.5));
}

.wp-table th:first-child,
.wp-table td:first-child {
  word-break: keep-all;
}

.wp-table th:nth-child(2),
.wp-table td:nth-child(2) {
  padding-right: 2rem;
  text-align: right;
  @media screen and (max-width: 800px) {
    padding-right: 1rem;
  }
  @media screen and (max-width: 400px) {
    padding-right: 2rem;
  }
  margin: auto;
}

.wp-table tr:last-child {
  border-bottom: none;
}

.wp-table td {
  font-weight: bold;
  padding-top: 1.5rem !important;
}

.wp-table td,
.wp-table th {
  padding: 8px 8px;
  display: table-cell;
  text-align: left;
  vertical-align: top;
  color: #333333;
}

.layout-zkm {
  margin-top: 2rem;
}

.zkm-price-layout {
  width: 100%;
}

.total-price-description-zkm {
  background-color: #f5f5f5;
  width: 100%;
  padding: 1rem 1.5rem;
  border: solid var(--grey-00, #333);
  border-width: 2px 0 0 0;
}

.total-price-description-regular-container {
  background-color: #f5f5f5;
  width: 100%;
  align-items: center;
  @media screen and (max-width: 992px) {
    position: fixed;
    bottom: 0;
  }
}

.total-price-description-regular {
  display: flex;
  padding: 1rem 1.5rem;
  align-items: center;
  gap: 1rem;
  width: 100%;
  background-color: #f5f5f5;
  border-top: 1px solid var(--stroke-one, rgba(151, 151, 151, 0.5));
}

.zkmButton {
  border-radius: 0;
  width: 100%;
  margin: 1rem;
}

.ticket-price-container-step-zkm {
  position: relative;
  border: solid var(--grey-00, #333);
  border-width: 0 0 2px 0;
  border-radius: 0;
  padding: 0;
}

.ticket-price-container-step-regular {
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid var(--stroke-one, rgba(151, 151, 151, 0.5));
  margin-top: 1.5rem;
  @media screen and (max-width: 800px) {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  @media screen and (max-width: 992px) {
    border: unset;
  }
  @media screen and (min-width: 993px) {
    margin-right: 1.5rem;
  }
}

@media screen and (max-width: 992px) {
  .ticket-price-container-step {
    margin: 12px;
    margin-bottom: 30px;
  }
}

@media (min-width: 992px) and (max-width: 1440px) {
  .ticket-price-container-step {
    border-radius: 8px 0 0 8px;
  }
}

.header-description {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  color: #665f5c;
  line-height: 20px;
  margin-bottom: 12px;
  padding: 10px 20px 10px 10px;
  display: flex;
  flex-direction: column;
}

.header-description-zkm {
  width: 100%;
}

.header-description-regular {
  padding: 0;
  margin: 0;
}

.zkm-price-table {
  width: 100%;
}

.element-description {
  display: flex;
  column-gap: 0.5rem;
  justify-content: space-between;
  margin-bottom: 8px;
}

.price-container-title {
  color: #ff4c00;
  font-family: Raleway, sans-serif;
  font-weight: bold;
  font-size: 18px;
  padding-left: 10px;
}

.price-container-title-zkm {
  color: #333333;
}

.price-container-title-regular {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  align-self: stretch;

  color: #333333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Source Sans Pro;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
}

.total-price-description {
  font-size: 18px;
  font-weight: bold;
  line-height: 23px;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
}

.total-price-container {
  display: flex;
  flex-direction: column;
  min-width: 7rem;
}

.total-price {
  display: block;
  color: #333333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Source Sans Pro;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 1.5rem */
  letter-spacing: -0.045rem;
  text-transform: uppercase;
}

.edit-cart {
  display: flex;
  padding-bottom: 0.25rem;
  align-items: center;
  gap: 0.375rem;
  border-bottom: 0.5px solid #333;

  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Raleway;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: 0.01313rem;
  text-transform: uppercase;
}

.edit-cart:hover {
  cursor: pointer;
}

.coreevent-fee-title {
  display: flex !important;
  align-items: center;
  gap: 0.38rem;
}

.fixed-fee-row:hover {
  cursor: pointer;
}

.not-logged-in {
  margin-top: -0.75rem;
  display: flex;
  font-size: 14px;
  justify-content: end;
  background-color: #f5f5f5;
  padding-right: 1rem;
  font-family: Raleway, sans-serif;
  font-style: italic;
  font-style: bold;
  font-weight: bold;
  color: #666;
  @media screen and (max-width: 992px) {
    padding-right: 2.5rem;
    margin-top: -0.75rem;
  }
}

.not-logged-in-zkm {
  @media screen and (max-width: 992px) {
    padding-right: 0.25rem !important;
  }
}
</style>
